// Single source of truth for every location dropdown across the site — hero
// banners, category pages, and forms (Add Business / Add Event / Deals).
// Keep this list alphabetical (city names only); "All Locations", "Other",
// and "Online" are appended separately by each consumer as needed so the
// base list stays reusable.
export const DFW_LOCATIONS = [
  "Addison",
  "Allen",
  "Anna",
  "Arlington",
  "Aubrey",
  "Carrollton",
  "Cedar Hill",
  "Coppell",
  "Dallas",
  "Denton",
  "DeSoto",
  "Duncanville",
  "Farmers Branch",
  "Flower Mound",
  "Fort Worth",
  "Frisco",
  "Garland",
  "Grand Prairie",
  "Highland Village",
  "Hutchins",
  "Irving",
  "Lewisville",
  "Little Elm",
  "Mansfield",
  "McKinney",
  "Melissa",
  "Mesquite",
  "Midlothian",
  "Plano",
  "Prosper",
  "Richardson",
  "Rockwall",
  "Rowlett",
  "Southlake",
  "Terrell",
  "The Colony",
];

// Full list including the catch-all "Other" — used by dropdowns that need to
// let a user pick a location not in the DFW list.
export const DFW_LOCATIONS_WITH_OTHER = [...DFW_LOCATIONS, "Other"];

// For hero search bars: "All Locations" first, then every city, then "Other".
export const HERO_LOCATIONS_ALL = ["All Locations", ...DFW_LOCATIONS, "Other"];

// For hero search bars that don't need an "Other" catch-all option.
export const HERO_LOCATIONS = ["All Locations", ...DFW_LOCATIONS];

/**
 * Consistent type-ahead filter for every location dropdown: matches on the
 * START of the city name (so typing "I" surfaces Irving, not "Farmers
 * Branch"). Case-insensitive. Always keep "All Locations" pinned visible
 * while a user is searching so it never disappears from the list.
 */
export function filterLocationsByPrefix(locations: string[], search: string): string[] {
  const s = search.trim().toLowerCase();
  if (!s) return locations;
  return locations.filter((loc) => {
    if (loc === "All Locations") return true;
    return loc.toLowerCase().startsWith(s);
  });
}
